export const FacebookSvg = () => {
  return (
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.0401 8.02005C16.0401 3.59298 12.4471 0 8.02005 0C3.59298 0 0 3.59298 0 8.02005C0 11.9018 2.7589 15.1338 6.41604 15.8797V10.4261H4.81203V8.02005H6.41604V6.01504C6.41604 4.46717 7.67519 3.20802 9.22306 3.20802H11.2281V5.61404H9.62406C9.18296 5.61404 8.82205 5.97494 8.82205 6.41604V8.02005H11.2281V10.4261H8.82205V16C12.8722 15.599 16.0401 12.1825 16.0401 8.02005Z"
        fill="#14A800"
      />
    </svg>
  );
};
